var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styles from '../SingleSelectQuestion/SingleSelectQuestion.css';
import Checkbox from '../../tailwind_common/Checkbox';
var MultiSelectOption = function (props) { return (React.createElement("div", { className: styles.multiSelectOption },
    React.createElement(Checkbox, __assign({ padding: "medium" }, props)))); };
export default MultiSelectOption;
